import { useState } from "react";
import PdfViewer from "../../../components/PdfViewer";
import { api } from "../../../services/api";
import { useQuery } from "@tanstack/react-query";
import React from "react";

function DocumentViewer({ onSelectDocument, selectedDocument, sessionId }: { onSelectDocument: (document: any) => void, selectedDocument?: any, sessionId?: string }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleSelectDocument = (document: any) => {
        onSelectDocument(document);
        setIsOpen(false);
    };

    const { data } = useQuery({
        queryKey: ["document-list"],
        queryFn: () => api.getSalesAidFiles(),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: isOpen,
    });

    const documents = data?.data || [];

    const handleButtonClick = () => {
        if (selectedDocument) {
            onSelectDocument(null);
        } else {
            setIsOpen(p => !p);
        }
    };

    return (
        <>
            {/* Sales Aid button - top right of left column, left of close button, aligned with Game/Practice Mode */}
            <div className="absolute right-[78px] top-10 z-[25]">
                <div className="flex flex-col items-end relative">
                    <button
                        data-tutorial-sales-aid-panel
                        className="h-10 flex items-center bg-background border border-gray2 text-text-primary rounded-full px-5 shadow-sm hover:opacity-90 transition-opacity font-medium text-base"
                        onClick={handleButtonClick}
                        aria-expanded={isOpen}
                        aria-haspopup="listbox"
                        aria-label="Sales Aid Panel"
                    >
                        Sales Aid Panel
                    </button>
                    {isOpen && (
                        <div
                            className="absolute top-full right-0 mt-2 bg-background rounded-lg py-2 shadow-lg z-50 min-w-[220px] max-h-[60vh] overflow-y-auto border border-gray2"
                            role="listbox"
                        >
                            {documents.map((item) => (
                                <button
                                    key={item.id}
                                    type="button"
                                    onClick={() => handleSelectDocument(item)}
                                    className="w-full text-left px-4 py-2.5 text-sm font-medium text-text-primary hover:bg-background3 transition-colors"
                                    role="option"
                                >
                                    {item.file_name}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Half-screen panel when a document is selected (like certification simulation) */}
            {selectedDocument && (
                <div className="fixed top-0 right-0 w-1/2 h-full z-[100] bg-white shadow-2xl flex flex-col">
                    <PdfViewer
                        fileId={selectedDocument.id}
                        displayName={selectedDocument.file_name}
                        sessionId={sessionId}
                        onClose={() => onSelectDocument(null)}
                        fillContainer
                    />
                </div>
            )}
        </>
    );
}

export default React.memo(DocumentViewer);